module.exports = __webpack_public_path__ + "static/happiness-4b83e9702488f812753d7904c6a1f194.png";